import script from "./AuditPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuditPage.vue?vue&type=script&lang=ts&setup=true"

import "./AuditPage.vue?vue&type=style&index=0&id=b3f0eabc&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3f0eabc"]])

export default __exports__